import { makeStyles } from "@material-ui/core/styles";

export const NavbarAuthenticationStyles = makeStyles(() => ({
  authentication: {
    float: "right"
  }
}));
